import shaka from 'shaka-player/dist/shaka-player.ui.js'
import { TypeChooseLayer, TypePlayList, ShakaPlayerConfig } from '../constant'

function getNewVideoSize(aspect, dimension) {
  const aspectArr = aspect.split(':')
  const aspectRatio = +aspectArr[0] / +aspectArr[1] // get digit aspect coefficient
  const { width, height } = dimension // get screen sizes
  const screenRatio = width / height// screen aspect coefficient
  let videoWidth
  let videoHeight
  const applyCoeff = screenRatio / aspectRatio // calc ratio of aspects
  if (applyCoeff >= 1) {
    // dimension.width >= dimension.height
    videoHeight = height
    videoWidth = height * aspectRatio
  } else {
    // dimension.width < dimension.height
    videoWidth = width
    videoHeight = width / aspectRatio
  }
  return {
    videoWidth,
    videoHeight,
  }
}

function getVideoStyles(aspect, width, height) {
  return {
    width: `${width}px`,
    height: `${height}px`,
    left: '50%',
    top: '50%',
    marginLeft: `-${width / 2}px`,
    marginTop: `-${height / 2}px`,
    objectFit: 'cover',
  }
}

const TextRunPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    content: String,
    _styleWrapper: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.content}</p>
    </div>
  },
  mounted() {
    if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
      this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
    }
  },
}

const RSSPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    item: Object,
    _styleWrapper: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.content}</p>
    </div>
  },
  data() {
    return {
      content: '',
      interval: '',
    }
  },
  mounted() {
    let that = this
    this.loadDataRss()
    this.interval = setInterval(() => {
      that.content = ''
      that.loadDataRss()
      // that.marquee()
    }, 30000)
  },
  methods: {
    loadDataRss() {
      let that = this
      this.$helper.loadDataSource({
        url: '/screen-file/getRss',
        dataSubmit: function () {
          return {
            url: that.item.url
          }
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            for (var i = 0; i < 10; i++) {
              var content = response.data.data[i].title + ' : ' + response.data.data[i].description.replace(/<[^>]*>?/gm, '')
                .replace(/\u00a0/g, ' ').replace(/\s/g, ' ').replace(/\xA0/g, ' ').replace(/&#160;/g, ' ') + ' '
              that.content += content
            }
            that.saveHistory(0);
          }
        },
        errorCallback: function (error) {
          that.saveHistory(2);
          // that.$helper.handleError(that.$router, error);
        },
      })
    },
    saveHistory(status) {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        this.$sendMessageSaveHistory(status, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
      }
    },
    marquee(args) {
      var that = $('p')
      var textWidth = this.textWidth(),
        offset = that.width().toFixed(0),
        width = offset,
        css = {
          'text-indent': that.css('text-indent'),
          'overflow': that.css('overflow'),
          'white-space': that.css('white-space')
        },
        marqueeCss = {
          'text-indent': width,
          'overflow': 'hidden',
          'white-space': 'nowrap'
        },
        args = $.extend(true, { count: -1, speed: 0, leftToRight: false }, args),
        i = 0,
        stop = textWidth * -1,
        dfd = $.Deferred()

      function go() {
        if (that.css('overflow') != 'hidden') {
          that.css('text-indent', width + 'px')
          return false
        }
        if (!that.length) return dfd.reject()
        if (width == stop) {
          i++
          if (i == args.count) {
            that.css(css)
            return dfd.resolve()
          }
          if (args.leftToRight) {
            width = textWidth * -1
          } else {
            width = offset
          }
        }
        that.css('text-indent', width + 'px')
        if (args.leftToRight) {
          width++
        } else {
          width--
        }
        setTimeout(go, args.speed)
      }

      if (args.leftToRight) {
        width = textWidth * -1
        width++
        stop = offset
      } else {
        width--
      }
      that.css(marqueeCss)
      go()
      return dfd.promise()
    },
    textWidth() {
      var calc = `<span style="display:none">${this.content}</span>`
      $('body').append(calc)
      var width = $('body').find('span:last').width()
      $('body').find('span:last').remove()
      return width
    }
  },
  destroyed() {
    clearInterval(this.interval)
  }
}

const TextNormalPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    content: String,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <div style={this._style}>{this.content}</div>
  },
  mounted() {
    if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
      this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
    }
  },
}

const ImageSinglePlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    url: String,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <img src={this.url} alt={this.url} style={this._style} />
  },
  mounted() {
    if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
      this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
    }
  },
}

const VideoSinglePlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    manifestUrl: {
      type: String,
      required: true
    },
    posterUrl: {
      type: String,
      required: false,
      default: ''
    },
    _styleContainer: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    },
    muted: Boolean,
    transform: Object,
    ratio: null
  },
  render() {
    return <div ref="videoContainer" style={this._styleContainer}>
      <video ref="videoPlayer" poster={this.posterUrl} style={this._style} loop muted={this.muted}></video>
    </div>
  },
  mounted() {
    shaka.polyfill.installAll()
    if (shaka.Player.isBrowserSupported()) {
      const player = new shaka.Player(this.$refs.videoPlayer)
      const ui = new shaka.ui.Overlay(
        player,
        this.$refs.videoContainer,
        this.$refs.videoPlayer
      )
      ui.getControls().setEnabledNativeControls(false)
      const config = {
        addSeekBar: false,
        controlPanelElements: ['overflow_menu'],
        // overflowMenuButtons: ['cast'],
      }
      ui.configure(config)

      player.configure({
        streaming: {
          retryParameters: { maxAttempts: ShakaPlayerConfig.MAXATTEMPTS, baseDelay: ShakaPlayerConfig.BASEDELAY }
        }
      });

      window.storage = new shaka.offline.Storage(player);

      window.storage.configure({
        offline: {
          usePersistentLicense: true
        }
      });

      player
        .load(this.manifestUrl)
        .then(() => {
          this.$refs.videoPlayer.play();
          this.saveHistory(0);
          this.downLoad(this.manifestUrl, this.fileId);
        }).catch(this.onError) // onError is executed if the asynchronous load fails.

      window.addEventListener('online', (event) => {
        let startTime = this.$refs.videoPlayer.currentTime;
        setTimeout(() => {
          player
            .load(this.manifestUrl)
            .then(() => {
              this.$refs.videoPlayer.currentTime = startTime;
              this.$refs.videoPlayer.play();
              if (!player.isLive()) {
                this.retryStream(player)
              }
            }).catch(this.onError)
        }, 10000)
      });

      window.addEventListener('offline', () => {
        let startTime = this.$refs.videoPlayer.currentTime;
        this.getStorageList().then((content) => {
          if (content != null && content.length > 0) {
            player
              .load(content[0].offlineUri).then(() => {
                this.$refs.videoPlayer.currentTime = startTime;
                this.$refs.videoPlayer.play();
              })
          }
        })
      });

    }
    this.loadAspectRatio()
  },
  methods: {
    onError(error) {
      this.saveHistory(2)
    },
    downLoad(manifestUrl, fileId) {
      this.deleteAll().then(function () {
        const metadata = {
          'title': 'ID-' + fileId,
          'downloaded': new Date()
        };
        window.storage.store(manifestUrl, metadata);
      });
    },
    async deleteAll() {
      window.indexedDB.deleteDatabase("shaka_offline_db")
    },
    getStorageList() {
      return window.storage.list();
    },
    retryStream(player) {
      setTimeout(() => {
        if (!player.isLive()) {
          player.retryStreaming();
        }
      }, 5000)
    },
    saveHistory(status) {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        this.$sendMessageSaveHistory(status, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
      }
    },
    loadAspectRatio(width, height) {
      let videoContainer = this.$refs.videoContainer
      let video = this.$refs.videoPlayer

      let dimensionWidth = videoContainer.offsetWidth
      let dimensionHeight = videoContainer.offsetHeight
      if (width && height) {
        dimensionWidth = width
        dimensionHeight = height
      }

      if (this.ratio == null || this.ratio == '' || this.ratio == undefined) {
        this.ratio = '16:9'
      }

      const { videoWidth, videoHeight } = getNewVideoSize(this.ratio, {
        width: dimensionWidth,
        height: dimensionHeight
      })

      const styles = getVideoStyles(this.ratio, videoWidth, videoHeight)

      Object.keys(styles).map(function (key, index) {
        video.style[key] = styles[key]
      })
    },
  },
  watch: {
    '_styleContainer': function () {
      this.loadAspectRatio(this.transform.width, this.transform.height)
    },
    'ratio': function () {
      this.loadAspectRatio(this.transform.width, this.transform.height)
    },
  }
}

const YoutubePlayer = {
  props: {
    idLayer: String,
    videoId: String,
    url: String,
    width: Number,
    height: Number,
    isMuted: Boolean,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    // return <iframe src={this.url} allowFullScreen allow="autoplay" width={this.width}
    //                frameBorder="0" height={this.height}></iframe>
    return <div id="player"></div>
  },
  data() {
    return {
      player: null,
      interval: null,
      isPlaying: false,
      numberLoadError: 0
    }
  },
  beforeCreate() {
    var tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  },
  created() {
  },
  mounted() {
    let that = this
    this.interval = setInterval(() => {
      if (!that.isPlaying) {
        that.onYouTubeIframeAPIReady()
      }
    }, 1000)
  },
  methods: {
    onYouTubeIframeAPIReady() {
      this.player = new YT.Player('player', {
        height: this.height,
        width: this.width,
        videoId: this.videoId,
        playerVars: {
          'autoplay': 1,
          // 'playsinline': 1,
          'rel': 0,
          'showinfo': 0,
          'playlist': this.videoId,
          'loop': 1,
          'mute': this.isMuted === true ? 1 : 0,
          'modestbranding': 1,
          'controls': 0,
          'disablekb': 1,
        },
        events: {
          'onReady': this.onPlayerReady,
          'onStateChange': this.onPlayerStateChange,
          'onError': this.onPlayerError
        }
      })
    },
    onPlayerReady(event) {
      event.target.playVideo()
      this.isPlaying = true
    },
    onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING) {
        this.saveHistory(0)
        this.numberLoadError = 0
      }
    },
    onPlayerError(event) {
      if (this.numberLoadError == 5) {
        this.saveHistory(2)
      } else {
        window.location.reload()
      }
      this.numberLoadError += 1
    },
    saveHistory(status) {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        this.$sendMessageSaveHistory(status, null, this.$store.state.messageSocket.id, this.videoId, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
      }
    }
  },
  watch: {
    isPlaying(value) {
      if (value) {
        clearInterval(this.interval)
      }
    }
  }
}

const DocumentPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    item: Object,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <img src={this.itemsImage[this.index]} alt={this.itemsImage[this.index]} style={this._style} />
  },
  data() {
    return {
      urlImage: '',
      itemsImage: [],
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.generateImageDocument()
    this.saveHistory()
  },
  methods: {
    generateImageDocument() {
      var documentConvert = this.item.urlDocumentConvert
      if (documentConvert) {
        if (documentConvert.includes(',')) {
          this.itemsImage = documentConvert.split(',')
        } else {
          this.itemsImage.push(documentConvert)
        }
      }
      this.nextImage()
    },
    nextImage() {
      let that = this
      var duration = that.item.duration.split(':') // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      setTimeout(() => {
        if (that.index < that.itemsImage.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
      }, seconds)
    },
    saveHistory() {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
      }
    }
  },
  watch: {
    index() {
      this.nextImage()
    }
  }
}

const VideoPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _styleContainer: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    },
    muted: Boolean,
    transform: Object,
    ratio: null
  },
  render() {
    return <div ref="videoContainer" style={this._styleContainer}>
      <video ref="videoPlayer" poster={this.posterUrl} style={this._style} muted={this.muted}></video>
    </div>
  },
  data() {
    return {
      indexVideo: 0,
      posterUrl: '',
      lengthHistory: 0
    }
  },
  mounted() {
    shaka.polyfill.installAll()
    if (shaka.Player.isBrowserSupported()) {
      const player = new shaka.Player(this.$refs.videoPlayer)
      const ui = new shaka.ui.Overlay(
        player,
        this.$refs.videoContainer,
        this.$refs.videoPlayer
      )
      ui.getControls().setEnabledNativeControls(false)
      const config = {
        addSeekBar: false,
        controlPanelElements: ['overflow_menu'],
        // overflowMenuButtons: ['cast'],
      }
      ui.configure(config)

      player.configure({
        streaming: {
          retryParameters: { maxAttempts: ShakaPlayerConfig.MAXATTEMPTS, baseDelay: ShakaPlayerConfig.BASEDELAY }
        }
      });

      window.storage = new shaka.offline.Storage(player);

      window.storage.configure({
        offline: {
          usePersistentLicense: true,
          progressCallback: function () {

          }
        }
      });

      let that = this
      player.load(this.items[this.indexVideo].url).then(() => {
        that.$refs.videoPlayer.play()
        that.saveHistory(0)
        this.downLoad(this.items)
      }).catch(this.onError)

      this.$refs.videoPlayer.addEventListener('ended', () => {
        if (window.navigator.onLine) {
          if (this.indexVideo < this.items.length - 1) {
            this.indexVideo += 1
          } else {
            this.indexVideo = 0
          }
          this.posterUrl = this.items[this.indexVideo].urlThumbnail != null ? this.items[this.indexVideo].urlThumbnail : ''
          player.load(this.items[this.indexVideo].url)
            .then(() => {
              this.$refs.videoPlayer.play()
              this.saveHistory(0)
            }).catch(this.onError)
        } else {
          this.getStorageList().then((content) => {
            if (content != null && content.length > 0) {
              if (this.indexVideo < content.length - 1) {
                this.indexVideo += 1
              } else {
                this.indexVideo = 0;
              }

              player
                .load(content[this.indexVideo].offlineUri).then(() => {
                  this.$refs.videoPlayer.play();
                })
            }
          })
        }


      })

      window.addEventListener('online', (event) => {
        let startTime = this.$refs.videoPlayer.currentTime;
        setTimeout(() => {
          player
            .load(this.items[this.indexVideo].url)
            .then(() => {
              this.$refs.videoPlayer.currentTime = startTime;
              this.$refs.videoPlayer.play();
              if (!player.isLive()) {
                this.retryStream(player)
              }
            }).catch(this.onError)
        }, 10000)
      });

      window.addEventListener('offline', () => {
        let startTime = this.$refs.videoPlayer.currentTime;
        this.getStorageList().then((content) => {
          if (content != null && content.length > 0) {
            if (this.indexVideo > content.length) {
              this.indexVideo = 0;
            }

            player
              .load(content[this.indexVideo].offlineUri).then(() => {
                this.$refs.videoPlayer.currentTime = startTime;
                this.$refs.videoPlayer.play();
              })
          }
        })
      });

    }
    this.loadAspectRatio();
  },
  methods: {
    onError(error) {
      this.saveHistory(2)
    },
    downLoad(items) {
      this.deleteAll().then(async () => {
        for await (const item of items) {
          const metadata = {
            'title': 'ID-' + item.fileId,
            'downloaded': new Date()
          };
          await window.storage.store(item.url, metadata);
        }
      });
    },
    async deleteAll() {
      window.indexedDB.deleteDatabase("shaka_offline_db")
    },
    getStorageList() {
      return window.storage.list();
    },
    retryStream(player) {
      setTimeout(() => {
        player.retryStreaming();
      }, 5000)
    },
    saveHistory(status) {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        if (this.lengthHistory < this.items.length) {
          let item = this.items[this.indexVideo]
          this.$sendMessageSaveHistory(status, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
          this.lengthHistory += 1
        }
      }
    },
    loadAspectRatio(width, height) {
      let videoContainer = this.$refs.videoContainer
      let video = this.$refs.videoPlayer

      let dimensionWidth = videoContainer.offsetWidth
      let dimensionHeight = videoContainer.offsetHeight
      if (width && height) {
        dimensionWidth = width
        dimensionHeight = height
      }

      if (this.ratio == null || this.ratio == '' || this.ratio == undefined) {
        this.ratio = '16:9'
      }

      const { videoWidth, videoHeight } = getNewVideoSize(this.ratio, {
        width: dimensionWidth,
        height: dimensionHeight
      })

      const styles = getVideoStyles(this.ratio, videoWidth, videoHeight)

      Object.keys(styles).map(function (key, index) {
        video.style[key] = styles[key]
      })
    },
  },
  watch: {
    '_styleContainer': function () {
      this.loadAspectRatio(this.transform.width, this.transform.height)
    },
    'ratio': function () {
      this.loadAspectRatio(this.transform.width, this.transform.height)
    },
  }
}

const ImagePlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <img src={this.items[this.index].url} alt={this.items[this.index].url} style={this._style} />
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.nextImage()
    this.saveHistory()
  },
  methods: {
    nextImage() {
      let that = this
      var duration = that.items[that.index].duration.split(':') // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
        this.saveHistory()
      }, seconds)
    },
    saveHistory() {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        if (this.lengthHistory < this.items.length) {
          let item = this.items[this.index]
          this.$sendMessageSaveHistory(0, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
          this.lengthHistory += 1
        }
      }
    }
  },
  watch: {
    index() {
      this.nextImage()
    }
  }
}
const DocumentPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return this.htmlContent
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0,
      dataImages: [],
      htmlContent: ''
    }
  },
  mounted() {
    this.generateDataImages()
    this.next()
  },
  methods: {
    generateDataImages() {
      this.items.map(each => {
        if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
          this.$sendMessageSaveHistory(0, each.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
        }
        each.urlImagesDoc.map(img => {
          this.dataImages.push({
            duration: each.duration,
            src: img
          })
        })
      })
      this.htmlContent =
        <img src={this.dataImages[this.index].src} alt={this.dataImages[this.index].src} style={this._style} />
    },
    next() {
      let that = this
      var duration = that.dataImages[that.index].duration.split(':') // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      setTimeout(() => {
        if (that.index < that.dataImages.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
      }, seconds)
    },
  },
  watch: {
    index() {
      this.next()
    }
  }
}
const TextNormalPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <div style={this._style} ref="textNormalContent">{this.items[this.index].content}</div>
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.nextContent()
    this.saveHistory()
  },
  methods: {
    nextContent() {
      let that = this
      var duration = that.items[that.index].duration.split(':')
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
        that.saveHistory()
      }, seconds)
    },
    saveHistory() {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
        if (this.lengthHistory < this.items.length) {
          let item = this.items[this.index]
          this.$sendMessageSaveHistory(0, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
          this.lengthHistory += 1
        }
      }
    }
  },
  watch: {
    index() {
      this.nextContent()
    }
  }
}
const TextRunPlayListPlayer = {
  props: {
    items: Object,
    idLayer: String,
    _styleWrapper: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.getContent}</p>
    </div>
  },
  computed: {
    getContent() {
      var _content = ''
      this.items.playListDetailModels.map(each => {
        if (each.content) {
          _content = _content.concat(each.content + ' ')
        }
      })
      return _content
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
      this.items.playListDetailModels.map(each => {
        this.$sendMessageSaveHistory(0, each.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
      })
    }
  },
  methods: {},
  watch: {}
}

const CentralPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _styleWrapper: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    },
    _styleContainer: {
      type: String,
      required: false,
      default: ""
    },
    muted: Boolean,
    transform: Object,
    ratio: null
  },
  render() {
    return this.htmlContent;
  },
  data() {
    return {
      index: 0,
      posterUrl: '',
      lengthHistory: 0,
      player: null,
      ui: null,
      htmlContent: ''
    }
  },
  mounted() {
    this.generateLayer();
  },
  methods: {
    generateLayer() {
      let that = this;
      if (this.items[this.index].typeFile == 0) {
        if (this.items[this.index].isRun === true) {
          this.htmlContent = <div class="scroll-left" style={this._styleWrapper}>
            <p class="marquee" style={this._style}>{this.items[this.index].content}</p>
          </div>
        } else {
          this.htmlContent = <div style={this._styleWrapper}>{this.items[this.index].content}</div>
          this.nextLayer();
        }
        this.player = null;
      } else if (this.items[this.index].typeFile == 1) {     /* File hình ảnh */
        this.htmlContent =
          <img src={this.items[this.index].url} alt="" style={this._style} />
        this.nextLayer();
        this.player = null;
      } else if (this.items[this.index].typeFile == 2) {   /* File Video */
        this.htmlContent =
          <div ref="videoContainer" style={this._styleContainer}>
            <video ref="videoPlayer" poster={this.posterUrl}
              style="position: absolute; top: 0; left: 0; width: 100%; height:100%;" muted={this.muted}>
            </video>
          </div>
        this.generateVideo();
      }
      that.saveHistory(0);
    },
    async generateVideo() {
      await this.sleep(100);
      if (shaka.Player.isBrowserSupported()) {
        if (this.player == null) {
          this.player = new shaka.Player(this.$refs.videoPlayer);
          this.ui = new shaka.ui.Overlay(
            this.player,
            this.$refs.videoContainer,
            this.$refs.videoPlayer
          );
          this.ui.getControls().setEnabledNativeControls(false);
          const config = {
            addSeekBar: false,
            controlPanelElements: ["overflow_menu"],
          };
          this.ui.configure(config);

          this.player.configure({
            streaming: {
              retryParameters: { maxAttempts: ShakaPlayerConfig.MAXATTEMPTS, baseDelay: ShakaPlayerConfig.BASEDELAY }
            }
          });

          window.storage = new shaka.offline.Storage(this.player);

          window.storage.configure({
            offline: {
              usePersistentLicense: true,
              progressCallback: function () {

              }
            }
          });

          this.player.load(this.items[this.index].url).then(() => {
            this.$refs.videoPlayer.play();
            this.downLoad(this.items);
          }).catch(this.onError);

          this.$refs.videoPlayer.addEventListener("ended", (e) => {
            if (window.navigator.onLine) {
              if (this.index < this.items.length - 1) {
                this.index += 1;
              } else {
                this.index = 0;
              }
              if (this.items[this.index].typeFile == TypePlayList.VIDEO) {
                this.posterUrl = this.items[this.index].urlThumbnail != null ? this.items[this.index].urlThumbnail : '';
                this.player.load(this.items[this.index].url)
                  .then(() => {
                    this.$refs.videoPlayer.play();
                  }).catch(this.onError);
              }
            } else {
              if (this.items[this.index].typeFile == TypePlayList.VIDEO) {
                this.getStorageList().then((content) => {
                  if (content != null && content.length > 0) {
                    if (this.index < content.length - 1) {
                      this.index += 1
                    } else {
                      this.index = 0;
                    }
  
                    this.player
                      .load(content[this.index].offlineUri).then(() => {
                        this.$refs.videoPlayer.play();
                      })
                  }
                })
              } else {
                if (this.index < this.items.length - 1) {
                  this.index += 1;
                } else {
                  this.index = 0;
                }
              }
            }

          })

          window.addEventListener('online', (event) => {
            let startTime = this.$refs.videoPlayer.currentTime;
            setTimeout(() => {
              this.player
                .load(this.items[this.index].url)
                .then(() => {
                  this.$refs.videoPlayer.currentTime = startTime;
                  this.$refs.videoPlayer.play();
                  if (!this.player.isLive()) {
                    this.retryStream(player)
                  }
                }).catch(this.onError)
            }, 10000)
          });

          window.addEventListener('offline', () => {
            let startTime = this.$refs.videoPlayer.currentTime;
            this.getStorageList().then((content) => {
              if (content != null && content.length > 0) {
                if (this.index > content.length) {
                  this.index = 0;
                }

                this.player
                  .load(content[this.index].offlineUri).then(() => {
                    this.$refs.videoPlayer.currentTime = startTime;
                    this.$refs.videoPlayer.play();
                  })
              }
            })
          });
        } else {

          this.player.configure({
            streaming: {
              retryParameters: { maxAttempts: ShakaPlayerConfig.MAXATTEMPTS, baseDelay: ShakaPlayerConfig.BASEDELAY }
            }
          });

          window.storage = new shaka.offline.Storage(this.player);

          window.storage.configure({
            offline: {
              usePersistentLicense: true
            }
          });

          this.player.load(this.items[this.index].url).then(() => {
            this.$refs.videoPlayer.play();
            this.downLoad(this.items);
          }).catch(this.onError);

          window.addEventListener('online', (event) => {
            let startTime = this.$refs.videoPlayer.currentTime;
            setTimeout(() => {
              this.player
                .load(this.manifestUrl)
                .then(() => {
                  this.$refs.videoPlayer.currentTime = startTime;
                  this.$refs.videoPlayer.play();
                  if (!this.player.isLive()) {
                    this.retryStream(player)
                  }
                }).catch(this.onError)
            }, 10000)
          });

          window.addEventListener('offline', () => {
            let startTime = this.$refs.videoPlayer.currentTime;
            this.getStorageList().then((content) => {
              if (content != null && content.length > 0) {
                this.player
                  .load(content[0].offlineUri).then(() => {
                    this.$refs.videoPlayer.currentTime = startTime;
                    this.$refs.videoPlayer.play();
                  })
              }
            })
          });
        }
      }
      this.loadAspectRatio();
    },
    downLoad(items) {
      this.deleteAll().then(async () => {
        for await (const item of items) {
          const metadata = {
            'title': 'ID-' + item.id,
            'downloaded': new Date()
          };
          await window.storage.store(item.url, metadata);
        }
      });
    },
    async deleteAll() {
      window.indexedDB.deleteDatabase("shaka_offline_db")
    },
    getStorageList() {
      return window.storage.list();
    },
    retryStream(player) {
      setTimeout(() => {
        player.retryStreaming();
      }, 5000)
    },
    loadAspectRatio(width, height) {
      let videoContainer = this.$refs.videoContainer
      let video = this.$refs.videoPlayer

      let dimensionWidth = videoContainer.offsetWidth
      let dimensionHeight = videoContainer.offsetHeight
      if (width && height) {
        dimensionWidth = width
        dimensionHeight = height
      }

      if (this.ratio == null || this.ratio == '' || this.ratio == undefined) {
        this.ratio = '16:9'
      }

      const { videoWidth, videoHeight } = getNewVideoSize(this.ratio, {
        width: dimensionWidth,
        height: dimensionHeight
      })

      const styles = getVideoStyles(this.ratio, videoWidth, videoHeight)

      Object.keys(styles).map(function (key, index) {
        video.style[key] = styles[key]
      })
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    onError(error) {
      this.saveHistory(2);
    },
    nextLayer() {
      let that = this;
      var duration = that.items[that.index].duration.split(':'); // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
      }, seconds)
    },
    saveHistory(status) {
      if (this.lengthHistory < this.items.length) {
        let item = this.items[this.index];
        this.$sendMessageSaveHistory(status, item.id, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        this.lengthHistory += 1;
      }
    }
  },
  watch: {
    index() {
      this.generateLayer();
    },
    '_styleWrapper': function (value) {
      this.htmlContent.elm.style = this._styleWrapper;
    },
    _style(value) {
      if (this.items[this.index].typeFile == 0) {
        this.htmlContent.elm.style = this._styleWrapper;
        this.htmlContent.elm.firstChild.style = value;
      } else {
        this.htmlContent.elm.style = value;
      }
    },
    // '_style': function () {
    //   this.loadAspectRatio(this.transform.width, this.transform.height)
    // },
    'ratio': function () {
      this.loadAspectRatio(this.transform.width, this.transform.height)
    },
    '_styleContainer': function () {
      if (this.items[this.index].typeFile == 2) {
        this.htmlContent.elm.style = this._styleContainer;
        this.loadAspectRatio(this.transform.width, this.transform.height)
      }
    },
    'muted': function(value) {
      this.$refs.videoPlayer.muted = value;
    }
  }
}

// const CentralPlayer = {
//   props: {
//     idLayer: String,
//     items: Array,
//     _styleWrapper: {
//       type: String,
//       required: false,
//       default: ''
//     },
//     _styleContainer: {
//       type: String,
//       required: false,
//       default: ''
//     },
//     _style: {
//       type: String,
//       required: false,
//       default: ''
//     },
//     muted: Boolean,
//     transform: Object,
//     ratio: null,
//   },
//   render() {
//     return this.htmlContent
//   },
//   data() {
//     return {
//       index: 0,
//       posterUrl: '',
//       lengthHistory: 0,
//       player: null,
//       ui: null,
//       htmlContent: ''
//     }
//   },
//   mounted() {
//     this.generateLayer();
//   },
//   methods: {
//     generateLayer() {
//       let that = this
//       if (that.items[that.index].typeFile == 0) {
//         if (that.items[that.index].isRun === true) {
//           that.htmlContent = <div class="scroll-left" style={that._styleWrapper}>
//             <p class="marquee" style={that._style}>{that.items[that.index].content}</p>
//           </div>
//         } else {
//           that.htmlContent = <div style={that._styleWrapper}>{that.items[that.index].content}</div>
//         }
//         that.nextLayer()
//         that.player = null
//       } else if (that.items[that.index].typeFile == 1) {     /* File hình ảnh */
//         that.htmlContent =
//           <img src={that.items[that.index].url} alt="" style={that._style}/>
//         that.nextLayer()
//         that.player = null
//       } else if (that.items[that.index].typeFile == 2) {   /* File Video */
//         that.htmlContent =
//           <div ref="videoContainer" style={that._styleContainer}>
//             <video ref="videoPlayer" poster={that.posterUrl}
//                    style="position: absolute; top: 0; left: 0; width: 100%; height:100%;" muted={that.muted}>
//             </video>
//           </div>
//         that.generateVideo()
//       }
//       that.saveHistory(0);
//     },
//     async generateVideo() {
//       await this.sleep(100)
//       shaka.polyfill.installAll()
//       if (shaka.Player.isBrowserSupported()) {
//         if (this.player == null) {
//           this.player = new shaka.Player(this.$refs.videoPlayer)
//           this.ui = new shaka.ui.Overlay(
//             this.player,
//             this.$refs.videoContainer,
//             this.$refs.videoPlayer
//           )
//           this.ui.getControls().setEnabledNativeControls(false)
//           const config = {
//             addSeekBar: false,
//             controlPanelElements: ['overflow_menu'],
//           }
//           this.ui.configure(config)

//           this.player.load(this.items[this.index].url).then(() => {
//             this.$refs.videoPlayer.play()
//           }).catch(this.onError)

//           this.$refs.videoPlayer.addEventListener('ended', (e) => {
//             if (this.index < this.items.length - 1) {
//               this.index += 1
//             } else {
//               this.index = 0
//               this.posterUrl = this.items[this.index].urlThumbnail != null ? this.items[this.index].urlThumbnail : ''
//               if (this.items[this.index].typeFile == TypePlayList.VIDEO) {
//                 this.player.load(this.items[this.index].url)
//                   .then(() => {
//                     this.$refs.videoPlayer.play()
//                   }).catch(this.onError)
//               }
//             }
//           })
//         } else {
//           this.player.load(this.items[this.index].url).then(() => {
//             this.$refs.videoPlayer.play()
//           }).catch(this.onError)
//         }
//       }

//       this.loadAspectRatio();
//     },
//     sleep(ms) {
//       return new Promise(resolve => setTimeout(resolve, ms))
//     },
//     onError(error) {
//       this.saveHistory(2)
//     },
//     nextLayer() {
//       let that = this
//       var item = that.items[that.index];
//       if (item.duration) {
//         var duration = that.items[that.index].duration.split(':') // split it at the colons
//         var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
//         setTimeout(() => {
//           if (that.index < that.items.length - 1) {
//             that.index += 1
//           } else {
//             that.index = 0
//           }
//         }, seconds)
//       }
//     },
//     saveHistory(status) {
//       if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
//         if (this.lengthHistory < this.items.length) {
//           let item = this.items[this.index]
//           this.$sendMessageSaveHistory(status, item.id, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer)
//           this.lengthHistory += 1
//         }
//       }
//     },
//     loadAspectRatio(width, height) {
//       debugger
//       let videoContainer = this.$refs.videoContainer
//       let video = this.$refs.videoPlayer

//       let dimensionWidth = videoContainer.offsetWidth
//       let dimensionHeight = videoContainer.offsetHeight
//       if (width && height) {
//         dimensionWidth = width
//         dimensionHeight = height
//       }

//       if (this.ratio == null || this.ratio == '' || this.ratio == undefined) {
//         this.ratio = '16:9'
//       }

//       const {videoWidth, videoHeight} = getNewVideoSize(this.ratio, {
//         width: dimensionWidth,
//         height: dimensionHeight
//       })

//       const styles = getVideoStyles(this.ratio, videoWidth, videoHeight)

//       Object.keys(styles).map(function (key, index) {
//         video.style[key] = styles[key]
//       })
//     },
//   },
//   watch: {
//     index() {
//       this.generateLayer()
//     },
//     '_styleContainer': function () {
//       this.htmlContent.elm.style = this._styleContainer;
//       this.loadAspectRatio(this.transform.width, this.transform.height)
//     },
//     'ratio': function () {
//       this.loadAspectRatio(this.transform.width, this.transform.height)
//     },
//   }
// }

const WidgetPlayer = {
  props: {
    items: Object,
    idLayer: String,
    jsx: Object,
    _styleWrapper: {
      type: String,
      required: false,
      default: ''
    },
    _style: {
      type: String,
      required: false,
      default: ''
    },
    _html: {
      type: String,
      required: false,
      default: ''
    },
    _script: {
      type: String,
      required: false,
      default: ''
    }
  },
  render() {
    // let html = this._html;
    // let _style = this._style;
    return this.jsx
  },
  created() {
    new Function(this._script)()
  },
  updated() {
    // this.$nextTick(function () {
    //   new Function(this._script)();
    // })
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    if (this.$router.currentRoute && this.$router.currentRoute.path !== '/preview.html') {
      this.$sendMessageSaveHistory(0, this.items.extractData.id, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer, TypeChooseLayer.WIDGET)
    }
  },
  methods: {},
  watch: {}
}

export default {
  textRunPlayer: TextRunPlayer,
  textNormalPlayer: TextNormalPlayer,
  imageSinglePlayer: ImageSinglePlayer,
  videoSinglePlayer: VideoSinglePlayer,

  youtubePlayer: YoutubePlayer,
  rssPlayer: RSSPlayer,
  documentPlayer: DocumentPlayer,

  videoPlayListPlayer: VideoPlayListPlayer,
  documentPlayListPlayer: DocumentPlayListPlayer,
  imagePlayListPlayer: ImagePlayListPlayer,
  textNormalPlayListPlayer: TextNormalPlayListPlayer,
  textRunPlayListPlayer: TextRunPlayListPlayer,

  centralPlayer: CentralPlayer,

  widgetPlayer: WidgetPlayer
}



// WEBPACK FOOTER //
// ./src/views/VideoPlayerComponent.js